export * from './mitarbeiter-list.component';
export * from './mitarbeiter-list.component.module';